import { CreateExerciseFactDTO, UpdateExerciseFactDTO } from '@/generated';
import { exerciseFactsApi } from '@/generated/clients';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from './query-hooks';

const refreshChannel = new BroadcastChannel('exercise-fact-refresh');

export const useCreateExerciseFact = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (createExerciseFactDTO: CreateExerciseFactDTO) => exerciseFactsApi.exerciseFactCreate({ createExerciseFactDTO: createExerciseFactDTO }),
    onSuccess: (_, dto) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.ExerciseFacts] });
      refreshChannel.postMessage('refresh');
    },
  });
};

export const useUpdateExerciseFact = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (updateExerciseFactDTO: UpdateExerciseFactDTO) => exerciseFactsApi.exerciseFactUpdate({ updateExerciseFactDTO: updateExerciseFactDTO }),
    onSuccess: (_, dto) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.ExerciseFacts] });
      refreshChannel.postMessage('refresh');
    },
  });
};
